module.exports = __webpack_public_path__ + "img/head-portrait.5a62ad19.0c6b537c.png";